import { render, staticRenderFns } from "./data28.vue?vue&type=template&id=eaddd7f8&scoped=true"
import script from "./data28.vue?vue&type=script&lang=js"
export * from "./data28.vue?vue&type=script&lang=js"
import style1 from "./data28.vue?vue&type=style&index=1&id=eaddd7f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaddd7f8",
  null
  
)

export default component.exports